var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Pin component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPin extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-pin', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.6263 7.45283C22.5328 7.17227 22.3458 6.89172 22.1587 6.61116L17.1087 1.56112C16.8281 1.37408 16.5476 1.18704 16.267 1.09352C15.9865 1 15.6124 1 15.2383 1C14.8642 1 14.5837 1.18704 14.3031 1.37408C14.0226 1.56112 13.742 1.84167 13.6485 2.12223L11.217 6.14356L4.39007 7.54635C4.10952 7.63987 3.82896 7.82691 3.64192 8.01395C3.45488 8.20099 3.26784 8.48154 3.17432 8.7621C3.0808 9.04266 3.0808 9.32322 3.17432 9.60378C3.26784 9.88434 3.36136 10.1649 3.64192 10.3519L8.03733 14.7473L1.21042 21.5742C0.929861 21.8548 0.929861 22.3224 1.21042 22.603C1.30394 22.6965 1.49098 22.79 1.67801 22.79C1.86505 22.79 2.05209 22.6965 2.14561 22.603L8.97252 15.7761L13.2744 20.0779C13.4614 20.265 13.742 20.3585 14.0226 20.452C14.1161 20.452 14.3031 20.452 14.3966 20.452C14.5837 20.452 14.6772 20.452 14.8642 20.3585C15.1448 20.265 15.4254 20.1715 15.6124 19.8909C15.7994 19.7039 15.9865 19.4233 15.9865 19.1427L17.5763 12.5029L21.6911 10.1649C21.9717 9.97785 22.2523 9.79082 22.4393 9.51026C22.6263 9.2297 22.7199 8.94914 22.8134 8.57506C22.8134 8.20099 22.7199 7.82691 22.6263 7.45283ZM21.2236 8.66858C21.13 8.7621 21.0365 8.85562 20.943 8.94914L16.6411 11.4742C16.4541 11.5677 16.3605 11.7547 16.267 11.9418L14.5837 18.8622C14.5837 18.8622 14.5837 18.9557 14.4902 18.9557L14.3966 19.0492H14.3031H14.2096L4.57711 9.32322L4.48359 9.2297V9.13618C4.48359 9.13618 4.48359 9.04266 4.57711 9.04266L4.67063 8.94914L11.6846 7.35931C11.8716 7.35931 12.0587 7.17227 12.1522 7.07876L14.7707 2.77687C14.8642 2.68335 14.9578 2.58983 15.0513 2.49631C15.1448 2.40279 15.2383 2.40279 15.4254 2.40279H15.5189C15.6124 2.40279 15.7059 2.40279 15.7994 2.40279C15.893 2.40279 16.08 2.49631 16.08 2.58983L21.13 7.63987C21.2235 7.73339 21.3171 7.82691 21.3171 8.01395C21.3171 8.20099 21.4106 8.29451 21.3171 8.38803C21.3171 8.48154 21.3171 8.57507 21.2236 8.66858Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconPin.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPin.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconPin.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconPin.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-pin') === undefined) {
    customElements.define('cat-icon-pin', BlocksIconPin);
}
